import React from 'react';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

function _empty() {}

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

function _continueIgnored(value) {
  if (value && value.then) {
    return value.then(_empty);
  }
}

function _rethrow(thrown, value) {
  if (thrown) throw value;
  return value;
}

function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, result);
}

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

function _callIgnored(body, direct) {
  return _call(body, _empty, direct);
}

function _invoke(body, then) {
  var result = body();

  if (result && result.then) {
    return result.then(then);
  }

  return then(result);
}

function _invokeIgnored(body) {
  var result = body();

  if (result && result.then) {
    return result.then(_empty);
  }
}

var refetchAllQueries = _async(function () {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      includeInactive = _ref7.includeInactive,
      _ref7$force = _ref7.force,
      force = _ref7$force === void 0 ? includeInactive : _ref7$force,
      shouldRefetchQuery = _ref7.shouldRefetchQuery;

  return Promise.all(queries.map(_async(function (query) {
    if (typeof shouldRefetchQuery !== 'undefined' && !shouldRefetchQuery(query)) {
      return;
    }

    return query.instances.length || includeInactive ? query.fetch({
      force: force
    }) : _await();
  })));
});
var refetchQuery = _async(function (queryKey) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _defaultConfig$queryK3 = defaultConfig.queryKeySerializerFn(queryKey),
      _defaultConfig$queryK4 = _slicedToArray(_defaultConfig$queryK3, 4),
      queryGroup = _defaultConfig$queryK4[1],
      variablesHash = _defaultConfig$queryK4[2],
      variables = _defaultConfig$queryK4[3]; // If we're simply refetching an existing query, then go find them
  // and call their fetch functions


  if (!queryGroup) {
    return;
  }

  return Promise.all(queries.map(_async(function (query) {
    if (query.queryGroup !== queryGroup) {
      return;
    }

    if (variables === false && query.variablesHash) {
      return;
    }

    if (variablesHash && query.variablesHash !== variablesHash) {
      return;
    }

    return _awaitIgnored(query.fetch({
      force: config.force
    }));
  })));
});
var prefetchQuery = _async(function (queryKey, queryFn) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  config = _objectSpread2({}, defaultConfig, {}, config, {
    prefetch: true
  });

  var _defaultConfig$queryK = defaultConfig.queryKeySerializerFn(queryKey),
      _defaultConfig$queryK2 = _slicedToArray(_defaultConfig$queryK, 4),
      queryHash = _defaultConfig$queryK2[0],
      queryGroup = _defaultConfig$queryK2[1],
      variablesHash = _defaultConfig$queryK2[2],
      variables = _defaultConfig$queryK2[3]; // If we're prefetching, use the queryFn to make the fetch call


  var query = queries.find(function (query) {
    return query.queryHash === queryHash;
  });

  if (query) {
    if (!config.force) {
      return;
    }

    query.config = config;
    query.queryFn = queryFn;
  } else {
    query = makeQuery({
      queryHash: queryHash,
      queryGroup: queryGroup,
      variablesHash: variablesHash,
      variables: variables,
      config: config,
      queryFn: queryFn
    });

    if (!isServer) {
      queries.push(query);
    }
  } // Trigger a query subscription with one-time unique id


  var unsubscribeFromQuery = query.subscribe({
    id: uid++,
    onStateUpdate: noop
  }); // Trigger a fetch and return the promise

  return _finallyRethrows(function () {
    return _await(query.fetch({
      force: config.force
    }));
  }, function (_wasThrown, _result3) {
    // Since this is not a hook, upsubscribe after we're done
    unsubscribeFromQuery();
    return _rethrow(_wasThrown, _result3);
  });
});
var queries = [];
var cancelledError = {};
var globalStateListeners = [];
var uid = 0;
var configContext = React.createContext();
var isServer = typeof window === 'undefined';

var noop = function noop() {};

var Console = console || {
  error: noop,
  warn: noop,
  log: noop
};
var defaultConfig = {
  retry: 3,
  retryDelay: function retryDelay(attemptIndex) {
    return Math.min(1000 * Math.pow(2, attemptIndex), 30000);
  },
  staleTime: 0,
  cacheTime: 5 * 60 * 1000,
  refetchAllOnWindowFocus: true,
  refetchInterval: false,
  suspense: false,
  queryKeySerializerFn: defaultQueryKeySerializerFn,
  throwOnError: true,
  useErrorBoundary: undefined // this will default to the suspense value

};
function setConsole(c) {
  Console = c;
}

var onWindowFocus = function onWindowFocus() {
  var _defaultConfig = defaultConfig,
      refetchAllOnWindowFocus = _defaultConfig.refetchAllOnWindowFocus;

  if (isDocumentVisible() && isOnline()) {
    refetchAllQueries({
      shouldRefetchQuery: function shouldRefetchQuery(query) {
        if (typeof query.config.refetchOnWindowFocus === 'undefined') {
          return refetchAllOnWindowFocus;
        } else {
          return query.config.refetchOnWindowFocus;
        }
      }
    })["catch"](function (error) {
      Console.error(error.message);
    });
  }
};

var removePreviousHandler;
function setFocusHandler(callback) {
  // Unsub the old watcher
  if (removePreviousHandler) {
    removePreviousHandler();
  } // Sub the new watcher


  removePreviousHandler = callback(onWindowFocus);
}
setFocusHandler(function (handleFocus) {
  // Listen to visibillitychange and focus
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('visibilitychange', handleFocus, false);
    window.addEventListener('focus', handleFocus, false);
    return function () {
      // Be sure to unsubscribe if a new handler is set
      window.removeEventListener('visibilitychange', handleFocus);
      window.removeEventListener('focus', handleFocus);
    };
  }
});
function ReactQueryConfigProvider(_ref) {
  var config = _ref.config,
      children = _ref.children;
  var configContextValue = React.useContext(configContext);
  var newConfig = React.useMemo(function () {
    var newConfig = _objectSpread2({}, configContextValue || defaultConfig, {}, config); // Default useErrorBoundary to the suspense value


    if (typeof newConfig.useErrorBoundary === 'undefined') {
      newConfig.useErrorBoundary = newConfig.suspense;
    }

    return newConfig;
  }, [config, configContextValue]);

  if (!configContextValue) {
    defaultConfig = newConfig;
  }

  return React.createElement(configContext.Provider, {
    value: newConfig
  }, children);
}

function useConfigContext() {
  return React.useContext(configContext) || defaultConfig;
}

function makeQuery(options) {
  var initialData = options.config.paginated ? [] : undefined;

  if (typeof options.config.initialData !== 'undefined') {
    initialData = options.config.initialData;
  }

  var query = _objectSpread2({}, options, {
    pageVariables: [],
    instances: [],
    state: {
      error: null,
      isFetching: false,
      isFetchingMore: false,
      canFetchMore: false,
      failureCount: 0,
      isCached: false,
      isStale: true,
      data: initialData
    } // promise: null,
    // staleTimeout: null,
    // cacheTimeout: null,
    // cancelled: null,

  });

  query.setState = function (updater) {
    query.state = functionalUpdate(updater, query.state);
    query.instances.forEach(function (instance) {
      instance.onStateUpdate(query.state);
    });
    globalStateListeners.forEach(function (d) {
      return d();
    });
  };

  query.subscribe = function (instance) {
    var found = query.instances.find(function (d) {
      return d.id === instance.id;
    });

    if (found) {
      Object.assign(found, instance);
    } else {
      found = instance;
      query.instances.push(instance);
    } // Mark as active


    query.setState(function (old) {
      return _objectSpread2({}, old, {
        isInactive: false
      });
    }); // Cancel garbage collection

    clearTimeout(query.cacheTimeout); // Mark the query as not cancelled

    query.cancelled = null; // Return the unsubscribe function

    return function () {
      query.instances = query.instances.filter(function (d) {
        return d.id !== instance.id;
      });

      if (!query.instances.length) {
        // Cancel any side-effects
        query.cancelled = cancelledError;

        if (query.cancelQueries) {
          query.cancelQueries();
        } // Mark as inactive


        query.setState(function (old) {
          return _objectSpread2({}, old, {
            isInactive: true
          });
        }); // Schedule garbage collection

        query.cacheTimeout = setTimeout(function () {
          queries.splice(queries.findIndex(function (d) {
            return d === query;
          }), 1);
          globalStateListeners.forEach(function (d) {
            return d();
          });
        }, query.state.isCached ? query.config.cacheTime : 0);
      }
    };
  }; // Set up the fetch function


  var tryFetchQueryPages = _async(function (pageVariables) {
    return _catch(function () {
      // Perform the query
      var promises = pageVariables.map(function (variables) {
        return query.queryFn(variables);
      });

      query.cancelQueries = function () {
        return promises.map(function (_ref2) {
          var cancel = _ref2.cancel;
          return cancel && cancel();
        });
      };

      return _await(Promise.all(promises), function (data) {
        if (query.cancelled) throw query.cancelled;
        return data;
      });
    }, function (error) {
      if (query.cancelled) throw query.cancelled; // If we fail, increase the failureCount

      query.setState(function (old) {
        return _objectSpread2({}, old, {
          failureCount: old.failureCount + 1
        });
      }); // Do we need to retry the request?

      if ( // Only retry if the document is visible
      query.config.retry === true || query.state.failureCount < query.config.retry) {
        if (!isDocumentVisible()) {
          return new Promise(function (r) {});
        } // Determine the retryDelay


        var delay = functionalUpdate(query.config.retryDelay, query.state.failureCount); // Return a new promise with the retry

        return new Promise(function (resolve, reject) {
          // Keep track of the retry timeout
          setTimeout(_async(function () {
            return query.cancelled ? reject(query.cancelled) : _catch(function () {
              return _await(tryFetchQueryPages(pageVariables), function (data) {
                if (query.cancelled) return reject(query.cancelled);
                resolve(data);
              });
            }, function (error) {
              if (query.cancelled) return reject(query.cancelled);
              reject(error);
            });
          }), delay);
        });
      }

      throw error;
    });
  });

  query.fetch = _async(function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$variables = _ref3.variables,
        variables = _ref3$variables === void 0 ? query.config.paginated && query.state.isCached ? query.pageVariables : query.variables : _ref3$variables,
        force = _ref3.force,
        isFetchMore = _ref3.isFetchMore;

    // Don't refetch fresh queries without force
    if (!query.queryHash || !query.state.isStale && !force) {
      return;
    } // Create a new promise for the query cache if necessary


    if (!query.promise) {
      query.promise = _async(function () {
        // If there are any retries pending for this query, kill them
        query.cancelled = null;

        var cleanup = function cleanup() {
          delete query.promise; // Schedule a fresh invalidation, always!

          clearTimeout(query.staleTimeout);
          query.staleTimeout = setTimeout(function () {
            if (query) {
              query.setState(function (old) {
                return _objectSpread2({}, old, {
                  isStale: true
                });
              });
            }
          }, query.config.staleTime);
          query.setState(function (old) {
            return _objectSpread2({}, old, {
              isFetching: false,
              isFetchingMore: false
            });
          });
        };

        return _catch(function () {
          // Set up the query refreshing state
          query.setState(function (old) {
            return _objectSpread2({}, old, {
              isFetching: true,
              isFetchingMore: isFetchMore,
              failureCount: 0
            });
          });
          variables = query.config.paginated && query.state.isCached && !isFetchMore ? variables : [variables]; // Try to fetch

          return _await(tryFetchQueryPages(variables), function (data) {
            // If we are paginating, and this is the first query or a fetch more
            // query, then store the variables in the pageVariables
            if (query.config.paginated && (isFetchMore || !query.state.isCached)) {
              query.pageVariables.push(variables[0]);
            } // Set data and mark it as cached


            query.setState(function (old) {
              data = query.config.paginated ? isFetchMore ? [].concat(_toConsumableArray(old.data), [data[0]]) : data : data[0];
              return _objectSpread2({}, old, {
                error: null,
                data: data,
                isCached: true,
                isStale: false
              }, query.config.paginated && {
                canFetchMore: query.config.getCanFetchMore(data[data.length - 1], data)
              });
            });
            query.instances.forEach(function (instance) {
              return instance.onSuccess && instance.onSuccess(query.state.data);
            });
            cleanup();
            return data;
          });
        }, function (error) {
          // As long as it's not a cancelled retry
          cleanup();

          if (error !== query.cancelled) {
            // Store the error
            query.setState(function (old) {
              return _objectSpread2({}, old, {
                error: error,
                isCached: false,
                isStale: true
              });
            });
            query.instances.forEach(function (instance) {
              return instance.onError && instance.onError(error);
            });
            throw error;
          }
        });
      })();
    }

    return query.promise;
  });

  query.setData = function (updater) {
    return query.setState(function (old) {
      return _objectSpread2({}, old, {
        data: functionalUpdate(updater, old.data)
      });
    });
  };

  return query;
}

function useQuery(queryKey, queryFn) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isMountedRef = React.useRef(false);
  var wasSuspendedRef = React.useRef(false);
  var instanceIdRef = React.useRef(uid++);
  var instanceId = instanceIdRef.current;
  config = _objectSpread2({}, useConfigContext(), {}, config);
  var _config = config,
      manual = _config.manual;

  var _config$queryKeySeria = config.queryKeySerializerFn(queryKey),
      _config$queryKeySeria2 = _slicedToArray(_config$queryKeySeria, 4),
      queryHash = _config$queryKeySeria2[0],
      queryGroup = _config$queryKeySeria2[1],
      variablesHash = _config$queryKeySeria2[2],
      variables = _config$queryKeySeria2[3];

  var query = queries.find(function (query) {
    return query.queryHash === queryHash;
  });
  var wasPrefetched;

  if (query) {
    wasPrefetched = query.config.prefetch;
    query.config = config;

    if (!isMountedRef.current) {
      query.config.prefetch = wasPrefetched;
    }

    query.queryFn = queryFn;
  } else {
    query = makeQuery({
      queryHash: queryHash,
      queryGroup: queryGroup,
      variablesHash: variablesHash,
      variables: variables,
      config: config,
      queryFn: queryFn
    });

    if (!isServer) {
      queries.push(query);
    }
  }

  React.useEffect(function () {
    if (config.refetchInterval && !query.refetchInterval) {
      query.refetchInterval = setInterval(function () {
        if (isDocumentVisible() || config.refetchIntervalInBackground) {
          try {
            query.fetch();
          } catch (err) {
            Console.error(err); // Swallow this error, since it is handled elsewhere
          }
        }
      }, config.refetchInterval);
      return function () {
        clearInterval(query.refetchInterval);
        query.refetchInterval = null;
      };
    }
  }, [config.refetchInterval, config.refetchIntervalInBackground, query]);

  var _React$useState = React.useState(query.state),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var onStateUpdate = React.useCallback(function (newState) {
    return setState(newState);
  }, []);
  var getLatestOnError = useGetLatest(config.onError);
  var getLatestOnSuccess = useGetLatest(config.onSuccess);
  React.useEffect(function () {
    var unsubscribeFromQuery = query.subscribe({
      id: instanceId,
      onStateUpdate: onStateUpdate,
      onSuccess: function onSuccess(data) {
        return getLatestOnSuccess() && getLatestOnSuccess()(data);
      },
      onError: function onError(err) {
        return getLatestOnError() && getLatestOnError()(err);
      }
    });
    return unsubscribeFromQuery;
  }, [getLatestOnError, getLatestOnSuccess, instanceId, onStateUpdate, query]);
  var isLoading = !state.isCached && query.state.isFetching;
  var refetch = query.fetch;
  var setData = query.setData;
  var fetchMore = React.useCallback(config.paginated ? function (paginationVariables) {
    return query.fetch({
      variables: paginationVariables,
      force: true,
      isFetchMore: true
    });
  } : undefined, [query]);
  var getLatestManual = useGetLatest(manual);
  React.useEffect(function () {
    if (getLatestManual()) {
      return;
    }

    if (config.suspense) {
      if (wasSuspendedRef.current || wasPrefetched) {
        return;
      }
    }

    var runRefetch = _async(function () {
      return _continueIgnored(_catch(function () {
        return _awaitIgnored(query.fetch());
      }, function (err) {
        Console.error(err); // Swallow this error. Don't rethrow it into a render function
      }));
    });

    runRefetch();
  }, [config.suspense, getLatestManual, query, wasPrefetched]);
  React.useEffect(function () {
    isMountedRef.current = true;
  }, []);

  if (config.suspense) {
    if (state.error) {
      throw state.error;
    }

    if (!state.isCached) {
      wasSuspendedRef.current = true;
      throw query.fetch();
    }
  }

  wasSuspendedRef.current = false;
  return _objectSpread2({}, state, {
    isLoading: isLoading,
    refetch: refetch,
    fetchMore: fetchMore,
    setData: setData
  });
}
function useMutation(mutationFn) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var refetchQueries = _ref4.refetchQueries,
      refetchQueriesOnFailure = _ref4.refetchQueriesOnFailure,
      config = _objectWithoutProperties(_ref4, ["refetchQueries", "refetchQueriesOnFailure"]);

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      data = _React$useState4[0],
      setData = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      error = _React$useState6[0],
      setError = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      isLoading = _React$useState8[0],
      setIsLoading = _React$useState8[1];

  var mutationFnRef = React.useRef();
  mutationFnRef.current = mutationFn;

  var _useConfigContext$con = _objectSpread2({}, useConfigContext(), {}, config),
      throwOnError = _useConfigContext$con.throwOnError,
      useErrorBoundary = _useConfigContext$con.useErrorBoundary;

  var mutate = React.useCallback(_async(function (variables) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        updateQuery = _ref5.updateQuery,
        _ref5$waitForRefetchQ = _ref5.waitForRefetchQueries,
        waitForRefetchQueries = _ref5$waitForRefetchQ === void 0 ? false : _ref5$waitForRefetchQ;

    setIsLoading(true);
    setError(null);

    var doRefetchQueries = _async(function () {
      var refetchPromises = refetchQueries.map(function (queryKey) {
        return refetchQuery(queryKey, {
          force: true
        });
      });
      return _invokeIgnored(function () {
        if (waitForRefetchQueries) {
          return _awaitIgnored(Promise.all(refetchPromises));
        }
      });
    });

    return _catch(function () {
      return _await(mutationFnRef.current(variables), function (res) {
        setData(res);

        if (updateQuery) {
          setQueryData(updateQuery, res, {
            shouldRefetch: false
          });
        }

        return _invoke(function () {
          if (refetchQueries) {
            return _continueIgnored(_catch(function () {
              return _callIgnored(doRefetchQueries);
            }, function (err) {
              Console.error(err); // Swallow this error since it is a side-effect
            }));
          }
        }, function () {
          setIsLoading(false);
          return res;
        });
      });
    }, function (error) {
      setError(error);
      return _invoke(function () {
        if (refetchQueriesOnFailure) {
          return _callIgnored(doRefetchQueries);
        }
      }, function () {
        setIsLoading(false);

        if (throwOnError) {
          throw error;
        }
      });
    });
  }), [refetchQueries, refetchQueriesOnFailure, throwOnError]);
  var reset = React.useCallback(function () {
    return setData(null);
  }, []);
  React.useEffect(function () {
    if (useErrorBoundary && error) {
      throw error;
    }
  }, [error, useErrorBoundary]);
  return [mutate, {
    data: data,
    isLoading: isLoading,
    error: error,
    reset: reset
  }];
}
function useIsFetching() {
  var _React$useState9 = React.useState({}),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      state = _React$useState10[0],
      setState = _React$useState10[1];

  var ref = React.useRef();

  if (!ref.current) {
    ref.current = function () {
      setState({});
    };

    globalStateListeners.push(ref.current);
  }

  React.useEffect(function () {
    return function () {
      globalStateListeners = globalStateListeners.filter(function (d) {
        return d !== ref.current;
      });
    };
  }, []);
  return React.useMemo(function () {
    return state && queries.some(function (query) {
      return query.state.isFetching;
    });
  }, [state]);
}
function setQueryData(userQueryKey, updater) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref6$shouldRefetch = _ref6.shouldRefetch,
      shouldRefetch = _ref6$shouldRefetch === void 0 ? true : _ref6$shouldRefetch;

  var _defaultConfig$queryK5 = defaultConfig.queryKeySerializerFn(userQueryKey),
      _defaultConfig$queryK6 = _slicedToArray(_defaultConfig$queryK5, 1),
      queryHash = _defaultConfig$queryK6[0];

  if (!queryHash) {
    return;
  }

  var query = queries.find(function (d) {
    return d.queryHash === queryHash;
  });

  if (!query) {
    return;
  }

  query.setData(updater);

  if (shouldRefetch) {
    return refetchQuery(userQueryKey);
  }
}
function clearQueryCache() {
  queries.length = 0;
}

function defaultQueryKeySerializerFn(queryKey) {
  if (!queryKey) {
    return [];
  }

  if (typeof queryKey === 'function') {
    try {
      return defaultQueryKeySerializerFn(queryKey());
    } catch (_unused) {
      return [];
    }
  }

  if (Array.isArray(queryKey)) {
    var _queryKey = _slicedToArray(queryKey, 2),
        id = _queryKey[0],
        variables = _queryKey[1];

    var variablesIsObject = isObject(variables);

    if (typeof id !== 'string' || variables && !variablesIsObject) {
      Console.warn('Tuple queryKey:', queryKey);
      throw new Error("Invalid query key tuple type: [".concat(_typeof(id), ", and ").concat(_typeof(variables), "]"));
    }

    var variablesHash = variablesIsObject ? stableStringify(variables) : '';
    return ["".concat(id).concat(variablesHash ? "_".concat(variablesHash) : ''), id, variablesHash, variables];
  }

  return [queryKey, queryKey];
}

function stableStringifyReplacer(_, value) {
  return isObject(value) ? Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.keys(value).sort().map(function (key) {
    return _defineProperty({}, key, value[key]);
  })))) : Array.isArray(value) ? value : String(value);
}

function stableStringify(obj) {
  return JSON.stringify(obj, stableStringifyReplacer);
}

function isObject(a) {
  return a && _typeof(a) === 'object' && !Array.isArray(a);
}

function isDocumentVisible() {
  return typeof document === 'undefined' || document.visibilityState === undefined || document.visibilityState === 'visible' || document.visibilityState === 'prerender';
}

function isOnline() {
  return navigator.onLine === undefined || navigator.onLine;
}

function useGetLatest(obj) {
  var ref = React.useRef();
  ref.current = obj;
  return React.useCallback(function () {
    return ref.current;
  }, []);
}

function functionalUpdate(updater, old) {
  return typeof updater === 'function' ? updater(old) : updater;
}

export { ReactQueryConfigProvider, clearQueryCache, globalStateListeners, prefetchQuery, queries, refetchAllQueries, refetchQuery, setConsole, setFocusHandler, setQueryData, stableStringify, useIsFetching, useMutation, useQuery };
//# sourceMappingURL=index.es.js.map
